import { Injectable, inject } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { from } from 'rxjs'
import { map, switchMap } from 'rxjs/operators'
import { UnlocodesService } from 'src/services/data/unlocodes.service'
import { ToasterService } from 'src/shared/toaster/toaster.service'
import { catchAndLog } from 'src/shared/utils/catch-and-log'
import { loadUnlocodes, loadUnlocodesFailure, loadUnlocodesSuccess } from './unlocode.actions'


@Injectable()
export class UnlocodeEffects {
  private readonly actions$ = inject(Actions)
  private readonly unlocodes = inject(UnlocodesService)
  private readonly toaster = inject(ToasterService)


  loadUnlocodes$ = createEffect(() => this.actions$.pipe(
    ofType(loadUnlocodes),
    switchMap(() =>
      from(this.unlocodes.getUnlocodes()).pipe(
        map(unlocodes => loadUnlocodesSuccess({ unlocodes })),
        catchAndLog(this.toaster, 'Unable to fetch unlocodes', loadUnlocodesFailure
      )))))
}
